export const JOURNEY_EVENT = "dh-journey-change";
export const JOURNEY_REVISION_KEY = "dh_j_revision";
export const JOURNEY_LIVE_INTERVAL_MS = 3000;

/** Same-tab signal. Other tabs pick this up via the storage event on the revision key. */
export function emitJourneyChange() {
  const at = String(Date.now());
  try {
    localStorage.setItem(JOURNEY_REVISION_KEY, at);
  } catch {
    /* ignore quota */
  }
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(JOURNEY_EVENT, { detail: { at } }));
}

export function isJourneyStorageKey(key) {
  if (!key) return false;
  return key === JOURNEY_REVISION_KEY || key.startsWith("dh_j_");
}
